<template>
    <div class="article">
        <div class="landing-container wrap">
            <div class="head">
                <div class="title">最新文章</div>
                <router-link :to="{ name: 'article'}">
                    <div class="link-blue more">more</div>
                </router-link>
            </div>
            <div class="article-wrap">
                <div class="item">
                    <router-link :to="{ name: 'articleDetail_6'}">
                        <div class="img-wrap">
                            <img src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_6.jpeg" alt="">
                        </div>
                        <div class="content">
                            <div class="title">租房可以換鎖嗎？是否該給房東一份備用鑰匙</div>
                            <div class="text">期透過友人分享實際發生的案例，一天半夜隔壁房的洗衣機水管突然爆裂，陽台開始積水，水也不停從陽台往下流，像是瀑布一樣的聲響引起整條巷子的人查看</div>
                        </div>
                    </router-link>
                </div>
                <div class="item">
                  <router-link :to="{ name: 'articleDetail_5'}">
                      <div class="img-wrap">
                          <img src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_5.jpeg" alt="">
                      </div>
                      <div class="content">
                          <div class="title">全台租金10年不減，租屋族的未來在哪裡</div>
                          <div class="text">現代年輕人，只要談到買房，總會出現心有餘而力不足的無奈，這居高不下的房價，讓多少年輕人寧願當個租屋族也不願犧牲生活品質買房，但談到租金，近年來也一直沒有下滑的的趨</div>
                      </div>
                  </router-link>
                </div>
                <div class="item">
                  <router-link :to="{ name: 'articleDetail_4'}">
                      <div class="img-wrap">
                          <img src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/article_4.jpeg" alt="">
                      </div>
                      <div class="content">
                          <div class="title">飛豬管家，物管公司分享產品使用心得</div>
                          <div class="text">台灣節節高升的房價，使得越來越多人購屋無望轉買為租，租屋已經成為了一種趨勢。租賃市場需求擴大，眾多的包租代管公司如雨後春筍般的成立，系統管理的需求也迫切產生。</div>
                      </div>
                  </router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data () {
        return{}
    }
}
</script>
<style lang="scss" scoped>
    .article{
        display: flex;
        justify-content: center;
        margin-top: 72px;
        margin-bottom: 85px;
        .wrap{
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .head{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                height: 38px;
                margin-bottom: 65px;
                >.title{
                    font-size: 26px;
                    font-weight: bold;
                }
                .more{
                    position: relative;
                    bottom: -10px;
                }
            }
            .article-wrap{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                .item{
                    border-radius: 36px;
                    box-shadow: 0 2px 17px 0 rgba(128, 150, 166, 0.29);
                    background-color: #ffffff;
                    width: 346px;
                    .img-wrap{
                        border-top-right-radius: 36px;
                        border-top-left-radius: 36px;
                        width: 100%;
                        height: 240px;
                        overflow: hidden;
                        img{
                            width: 100%;
                            height: 230px;
                        }
                    }
                    .content{
                        padding: 32px 30px 40px 30px;
                        .title{
                            font-size: 20px;
                            font-weight: 500;
                            margin-bottom: 14px;
                            height: 58px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .text{
                            font-size: 16px;
                            color: #626262;
                            max-height: 72px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 3;
                            -webkit-box-orient: vertical;
                        }
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1100px) {
        .article{
            padding: 0 29px;
            margin-top: 51px;
            margin-bottom: 80px;
            .wrap{
                .head{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    width: 100%;
                    height: 38px;
                    margin-bottom: 65px;
                    >.title{
                        font-size: 20px;
                        font-weight: bold;
                    }
                    .more{
                        position: relative;
                        bottom: -10px;
                    }
                }
                .article-wrap{
                    .item{
                        border-radius: 36px;
                        box-shadow: 0 2px 17px 0 rgba(128, 150, 166, 0.29);
                        background-color: #ffffff;
                        width: 48%;
                        &:last-child{
                            display: none;
                        }
                        .img-wrap{
                            width: 100%;
                            height: unset;
                            overflow: hidden;
                            img{
                                width: 100%;
                                height: unset;
                            }
                        }
                        .content{
                            padding: 8px 13px 20px 13px;
                            .title{
                                font-size: 14px;
                                margin-bottom: 8px;
                                max-height: 40px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                            .text{
                                font-size: 12px;
                                color: #626262;
                                line-height: 18px;
                                max-height: 18px;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                display: -webkit-box;
                                -webkit-line-clamp: 2;
                                -webkit-box-orient: vertical;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/officailPage/home/article.vue